module.exports = require("core-js-pure/stable/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/define-property.js
// module id = 605
// module chunks = 0